<template>
  <div class="lease-overview">
    <!-- 本月待续费 + 本月新装 -->
    <div class="row-2">
      <section class="card card--month-renewal">
        <h3 class="section-title"><span class="title-bar" />本月待续费概况</h3>
        <div class="metric-pair">
          <div class="metric-block">
            <div class="metric-label">本月待续费设备</div>
            <div class="metric-value">
              <span class="num">{{ fmtNum(d.monthRenewal.pendingDevices.value) }}</span>
              <span class="unit">{{ d.monthRenewal.pendingDevices.unit }}</span>
            </div>
            <div class="progress-wrap">
              <span class="field-label">达成率</span>
              <span class="field-value">{{ fmtRate(d.monthRenewal.pendingDevices.rate) }}%</span>
              <div class="progress-track"><div class="progress-fill progress-fill--blue" :style="{ width: progressWidth(d.monthRenewal.pendingDevices.rate) }" /></div>
            </div>
          </div>
          <div class="metric-block">
            <div class="metric-label">本月续约预计应收金额</div>
            <div class="metric-value">
              <span class="num">{{ fmtAmount(d.monthRenewal.expectedAmount.value) }}</span>
              <span class="unit">{{ d.monthRenewal.expectedAmount.unit }}</span>
            </div>
            <div class="progress-wrap">
              <span class="field-label">达成率</span>
              <span class="field-value">{{ fmtRate(d.monthRenewal.expectedAmount.rate) }}%</span>
              <div class="progress-track"><div class="progress-fill progress-fill--blue" :style="{ width: progressWidth(d.monthRenewal.expectedAmount.rate) }" /></div>
            </div>
          </div>
        </div>
        <div class="breakdown-list">
          <div v-for="row in d.monthRenewal.rows" :key="row.type" class="breakdown-item">
            <div class="bd-grid bd-grid--renewal">
              <div class="bd-line">
                <div class="bd-cell bd-cell--primary">
                  <span class="bd-icon-wrap"><dashboard-icons :name="row.type === 'time' ? 'time' : 'service'" size="18" color="#5b8ff9" /></span>
                  <div class="bd-primary-body">
                    <span class="bd-type" :class="'bd-type--' + row.type">{{ row.label }}</span>
                    <span class="bd-num bd-num--qty"><span class="field-value">{{ fmtNum(row.pendingDevices) }}</span><span class="field-unit">台</span></span>
                    <span class="bd-num bd-num--amt"><span class="field-value">{{ fmtAmount(row.pendingAmount) }}</span><span class="field-unit">元</span></span>
                  </div>
                </div>
                <div class="bd-cell bd-cell--mid-stack">
                  <div class="bd-side-row">
                    <span class="field-label">已续租</span>
                    <span class="field-value">{{ fmtNum(row.renewedDevices) }}</span><span class="field-unit">台</span>
                  </div>
                  <div class="bd-side-row">
                    <span class="field-label">已续费</span>
                    <span class="field-value">{{ fmtAmount(row.renewedAmount) }}</span><span class="field-unit">元</span>
                  </div>
                </div>
                <div class="bd-cell bd-cell--rate-stack">
                  <div class="bd-side-row">
                    <span class="field-label">达成率</span>
                    <span class="field-value">{{ fmtRate(row.deviceRate) }}%</span>
                  </div>
                  <div class="bd-side-row">
                    <span class="field-label">达成率</span>
                    <span class="field-value">{{ fmtRate(row.amountRate) }}%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="card card--new-install">
        <h3 class="section-title"><span class="title-bar" />本月租赁新装概况</h3>
        <div class="metric-pair">
          <div class="metric-block" v-for="block in [d.monthNewInstall.devices, d.monthNewInstall.amount]" :key="block.unit">
            <div class="metric-label">{{ block.unit === '台' ? '本月新装设备' : '本月新装设备金额' }}</div>
            <div class="metric-value">
              <span class="num">{{ block.unit === '台' ? fmtNum(block.value) : fmtAmount(block.value) }}</span>
              <span class="unit">{{ block.unit }}</span>
            </div>
            <div class="trend-row">
              <span class="trend" :class="block.momUp ? 'trend--up' : 'trend--down'">
                <span class="field-label">环比</span>
                <span class="field-value">{{ fmtRate(block.mom) }}%</span>
                <dashboard-icons :name="block.momUp ? 'trendUp' : 'trendDown'" size="12" :color="trendArrowColor(block.momUp)" />
              </span>
              <span class="trend" :class="block.yoyUp ? 'trend--up' : 'trend--down'">
                <span class="field-label">同比</span>
                <span class="field-value">{{ fmtRate(block.yoy) }}%</span>
                <dashboard-icons :name="block.yoyUp ? 'trendUp' : 'trendDown'" size="12" :color="trendArrowColor(block.yoyUp)" />
              </span>
            </div>
          </div>
        </div>
        <div class="breakdown-list">
          <div v-for="row in d.monthNewInstall.rows" :key="row.type" class="breakdown-item">
            <div class="bd-grid bd-grid--install">
              <div class="bd-line">
                <div class="bd-cell bd-cell--primary">
                  <span class="bd-icon-wrap">
                    <dashboard-icons
                      :name="row.type === 'time' ? 'time' : 'traffic'"
                      size="18"
                      :color="row.type === 'time' ? '#5b8ff9' : '#9254de'"
                    />
                  </span>
                  <div class="bd-primary-body">
                    <span class="bd-type" :class="'bd-type--' + row.type">{{ row.label }}</span>
                    <span class="bd-num bd-num--qty"><span class="field-value">{{ fmtNum(row.devices) }}</span><span class="field-unit">台</span></span>
                    <span class="bd-num bd-num--amt"><span class="field-value">{{ fmtAmount(row.amount) }}</span><span class="field-unit">元</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 在租 + 异常 -->
    <div class="row-2">
      <section class="card card--leasing">
        <h3 class="section-title">
          <span class="title-bar" />在租设备概况
          <span class="title-extra">
            <span class="field-label">总数</span>
            <span class="summary-total-num">{{ fmtNum(d.leasingDevices.total) }}</span>
            <span class="summary-total-unit">台</span>
          </span>
        </h3>
        <div class="type-cards">
          <div class="type-card type-card--time">
            <span class="type-card-watermark" aria-hidden="true"><dashboard-icons name="time" :size="80" color="rgba(255,255,255,0.22)" /></span>
            <div class="type-card-head">
              <span class="type-card-icon-badge type-card-icon-badge--time">
                <dashboard-icons name="time" size="18" color="#5b9fff" />
              </span>
              <span class="type-card-title">时间型总数</span>
            </div>
            <div class="type-card-foot">
              <div class="type-card-count">
                <span class="type-card-count-num">{{ fmtNum(d.leasingDevices.time.count) }}</span>
                <span class="type-card-count-unit">台</span>
              </div>
              <div class="type-card-ratio">占比 {{ fmtRate(d.leasingDevices.time.ratio) }}%</div>
            </div>
          </div>
          <div class="type-card type-card--traffic">
            <span class="type-card-watermark" aria-hidden="true"><dashboard-icons name="traffic" :size="80" color="rgba(255,255,255,0.22)" /></span>
            <div class="type-card-head">
              <span class="type-card-icon-badge type-card-icon-badge--traffic">
                <dashboard-icons name="traffic" size="18" color="#9b6fd6" />
              </span>
              <span class="type-card-title">流量型总数</span>
            </div>
            <div class="type-card-foot">
              <div class="type-card-count">
                <span class="type-card-count-num">{{ fmtNum(d.leasingDevices.traffic.count) }}</span>
                <span class="type-card-count-unit">台</span>
              </div>
              <div class="type-card-ratio">占比 {{ fmtRate(d.leasingDevices.traffic.ratio) }}%</div>
            </div>
          </div>
        </div>
        <button type="button" class="expand-btn" @click="yearExpanded = !yearExpanded">
          <dashboard-icons name="expand" size="14" color="#1890ff" />
          {{ yearExpanded ? '收起今年详细数据' : '展开今年详细数据' }}
        </button>
      </section>

      <section class="card card--abnormal">
        <h3 class="section-title">
          <span class="title-bar" />异常设备概况
        </h3>
        <div class="abnormal-grid">
          <div v-for="item in d.abnormalDevices.items" :key="item.key" class="abnormal-item">
            <div class="abnormal-icon-wrap">
              <dashboard-icons :name="item.key" size="22" color="#fa8c16" />
            </div>
            <div class="abnormal-label">{{ item.label }}</div>
            <div class="abnormal-count">
              <span class="abnormal-count-num">{{ fmtNum(item.count) }}</span>
              <span class="abnormal-count-unit">台</span>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 今年新增 + 今年收入 -->
    <div class="row-2">
      <section class="card card--year-new">
        <h3 class="section-title"><span class="title-bar" />今年新增租赁设备概况</h3>
        <div class="year-new-panel">
          <div class="year-new-summary-top">
            <div class="year-new-metric-label">今年新增设备总数</div>
            <div class="year-new-metric-row">
              <div class="metric-value metric-value--lg">
                <span class="num">{{ fmtNum(d.yearNewDevices.total) }}</span>
                <span class="unit">台</span>
              </div>
              <span class="year-new-stat-extra year-new-trend trend" :class="d.yearNewDevices.momUp ? 'trend--up' : 'trend--down'">
                <span class="year-new-stat-label">环比</span>
                <span class="year-new-stat-value">{{ fmtRate(d.yearNewDevices.mom) }}%</span>
                <dashboard-icons
                  :name="d.yearNewDevices.momUp ? 'trendUp' : 'trendDown'"
                  size="12"
                  :color="trendArrowColor(d.yearNewDevices.momUp)"
                />
              </span>
            </div>
          </div>
          <div class="year-new-types">
            <div v-for="t in d.yearNewDevices.types" :key="t.label" class="year-new-type-row">
              <div class="year-new-type-left">
                <dashboard-icons :name="t.label === '时间型' ? 'time' : 'traffic'" size="16" :color="t.label === '时间型' ? '#5b9fff' : '#9b6fd6'" />
                <span class="year-new-type-name">{{ t.label }}</span>
                <span class="year-new-type-count"><span class="field-value">{{ fmtNum(t.count) }}</span><span class="field-unit">台</span></span>
              </div>
              <span class="year-new-stat-extra year-new-type-ratio">
                <span class="year-new-stat-label">占比</span>
                <span class="year-new-stat-value">{{ fmtRate(t.ratio) }}%</span>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section class="card card--revenue">
        <h3 class="section-title"><span class="title-bar" />今年租赁收入概况</h3>
        <div class="revenue-panel">
          <div class="revenue-col-top">
            <div class="revenue-col-title">今年租赁收入</div>
            <div class="year-new-metric-row">
              <div class="metric-value metric-value--lg">
                <span class="num">{{ fmtAmount(d.yearRevenue.total.amount) }}</span>
                <span class="unit">元</span>
              </div>
              <span class="year-new-stat-extra year-new-trend trend" :class="d.yearRevenue.total.momUp ? 'trend--up' : 'trend--down'">
                <span class="year-new-stat-label">环比</span>
                <span class="year-new-stat-value">{{ fmtRate(d.yearRevenue.total.mom) }}%</span>
                <dashboard-icons
                  :name="d.yearRevenue.total.momUp ? 'trendUp' : 'trendDown'"
                  size="12"
                  :color="trendArrowColor(d.yearRevenue.total.momUp)"
                />
              </span>
            </div>
          </div>
          <div class="revenue-col-bottom">
            <div v-for="t in d.yearRevenue.total.types" :key="t.label" class="year-new-type-row">
              <div class="revenue-detail-left">
                <dashboard-icons :name="t.label === '时间型' ? 'time' : 'traffic'" size="16" :color="t.label === '时间型' ? '#5b9fff' : '#9b6fd6'" />
                <span class="revenue-detail-name">{{ t.label }}</span>
                <span class="revenue-detail-val"><span class="field-value">{{ fmtAmount(t.amount) }}</span><span class="field-unit">元</span></span>
              </div>
              <span class="year-new-stat-extra">
                <span class="year-new-stat-label">占比</span>
                <span class="year-new-stat-value">{{ fmtRate(t.ratio) }}%</span>
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import DashboardIcons from './DashboardIcons.vue'
import { getDashboardLeaseOverview } from '@/api/dashboard'
import { formatDashboardNum, formatDashboardAmount } from './dashboardLeaseMock'

function emptyRenewalRow(type, label) {
  return {
    type,
    label,
    pendingDevices: 0,
    pendingAmount: 0,
    renewedDevices: 0,
    renewedAmount: 0,
    deviceRate: 0,
    amountRate: 0,
  }
}

function emptyTrend(unit) {
  return { value: 0, unit, mom: 0, momUp: true, yoy: 0, yoyUp: true }
}

function emptyLeaseOverview() {
  return {
    monthRenewal: {
      pendingDevices: { value: 0, unit: '台', rate: 0 },
      expectedAmount: { value: 0, unit: '元', rate: 0 },
      rows: [emptyRenewalRow('time', '时间型'), emptyRenewalRow('service', '服务包')],
    },
    monthNewInstall: {
      devices: emptyTrend('台'),
      amount: emptyTrend('元'),
      rows: [
        { type: 'time', label: '时间型', devices: 0, amount: 0 },
        { type: 'traffic', label: '流量型', devices: 0, amount: 0 },
      ],
    },
    leasingDevices: {
      total: 0,
      time: { count: 0, ratio: 0 },
      traffic: { count: 0, ratio: 0 },
    },
    abnormalDevices: {
      items: [
        { key: 'waterQuality', label: '水质异常', count: 0 },
        { key: 'offline', label: '离线超30天', count: 0 },
        { key: 'fault', label: '故障码超24小时', count: 0 },
      ],
    },
    yearNewDevices: {
      total: 0,
      mom: 0,
      momUp: true,
      types: [
        { label: '时间型', count: 0, ratio: 0 },
        { label: '流量型', count: 0, ratio: 0 },
      ],
    },
    yearRevenue: {
      total: {
        amount: 0,
        mom: 0,
        momUp: true,
        types: [
          { label: '时间型', amount: 0, ratio: 0 },
          { label: '流量型', amount: 0, ratio: 0 },
        ],
      },
    },
  }
}

export default {
  name: 'DashboardLeaseOverview',
  components: { DashboardIcons },
  data() {
    return {
      d: emptyLeaseOverview(),
      yearExpanded: false,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const res = await getDashboardLeaseOverview()
        if (res && res.data) {
          const empty = emptyLeaseOverview()
          this.d = {
            ...empty,
            ...res.data,
            monthRenewal: { ...empty.monthRenewal, ...(res.data.monthRenewal || {}) },
            monthNewInstall: {
              ...empty.monthNewInstall,
              ...(res.data.monthNewInstall || {}),
              devices: { ...empty.monthNewInstall.devices, ...((res.data.monthNewInstall && res.data.monthNewInstall.devices) || {}) },
              amount: { ...empty.monthNewInstall.amount, ...((res.data.monthNewInstall && res.data.monthNewInstall.amount) || {}) },
            },
            leasingDevices: {
              ...empty.leasingDevices,
              ...(res.data.leasingDevices || {}),
              time: { ...empty.leasingDevices.time, ...((res.data.leasingDevices && res.data.leasingDevices.time) || {}) },
              traffic: { ...empty.leasingDevices.traffic, ...((res.data.leasingDevices && res.data.leasingDevices.traffic) || {}) },
            },
            abnormalDevices: { ...empty.abnormalDevices, ...(res.data.abnormalDevices || {}) },
            yearNewDevices: { ...empty.yearNewDevices, ...(res.data.yearNewDevices || {}) },
            yearRevenue: {
              total: { ...empty.yearRevenue.total, ...((res.data.yearRevenue && res.data.yearRevenue.total) || {}) },
            },
          }
        }
      } catch (e) {
        ElMessage.error(e.message || '加载租赁业务概况失败')
      }
    },
    fmtNum: formatDashboardNum,
    fmtAmount: formatDashboardAmount,
    fmtRate(n) {
      const v = Number(n)
      if (Number.isNaN(v)) return '0.00'
      return v.toFixed(2)
    },
    progressWidth(n) {
      const v = Number(n)
      if (Number.isNaN(v) || v <= 0) return '0%'
      return Math.min(v, 100) + '%'
    },
    trendArrowColor(isUp) {
      return isUp ? '#f5222d' : '#52c41a'
    },
  },
}
</script>

<style scoped>
/* 属性名 / 属性值（常规表单阅读层级） */
.field-label {
  color: #8c8c8c;
  font-size: 13px;
  font-weight: 400;
}

.field-value {
  color: #262626;
  font-size: 14px;
  font-weight: 600;
}

.field-value--md {
  font-size: 15px;
}

.field-value--lg {
  font-size: 19px;
}

.field-unit {
  color: #262626;
  font-size: 14px;
  font-weight: 400;
}

.lease-overview {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.row-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
}

.row-2 > .card {
  min-width: 0;
}

.card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 16px 18px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.section-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin: 0 0 18px;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  line-height: 1.4;
}

.title-bar {
  display: inline-block;
  width: 4px;
  height: 16px;
  margin-right: 8px;
  background: #1890ff;
  border-radius: 1px;
  flex-shrink: 0;
}

.title-extra {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  margin-left: auto;
  flex-shrink: 0;
}

.card--leasing .title-extra .field-label,
.card--abnormal .title-extra .field-label {
  font-size: 14px;
  font-weight: 400;
  color: #8c8c8c;
}

.card--leasing .summary-total-num,
.card--abnormal .summary-total-num {
  font-size: clamp(27px, 2.8vw, 33px);
  font-weight: 600;
  color: #262626;
  line-height: 1.1;
}

.card--leasing .summary-total-unit,
.card--abnormal .summary-total-unit {
  font-size: 14px;
  font-weight: 400;
  color: #262626;
  line-height: 1.2;
  padding-bottom: 2px;
}

.metric-pair {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.metric-block {
  min-width: 0;
}

.metric-label {
  font-size: 14px;
  color: #8c8c8c;
  font-weight: 400;
  margin-bottom: 8px;
}

.metric-pair .metric-label {
  color: #262626;
  font-weight: 600;
}

/* 本月待续费 + 本月新装（顶区 KPI + 明细，对齐设计稿字号） */
.row-2 > .card .metric-pair .metric-label {
  font-size: 15px;
  margin-bottom: 10px;
}

.row-2 > .card .metric-value {
  margin-bottom: 8px;
}

.row-2 > .card .metric-value .num {
  font-size: clamp(25px, 2.5vw, 29px);
  font-weight: 600;
  line-height: 1.15;
}

.row-2 > .card:not(.card--new-install) .metric-value .num {
  color: #1890ff;
}

.row-2 > .card .metric-value .unit {
  font-size: 14px;
  font-weight: 400;
  color: #8c8c8c;
  padding-bottom: 3px;
}

.card--new-install .metric-value .num {
  color: #9254de;
}

.card--new-install .title-bar {
  background: #9254de;
}

.row-2 > .card .progress-wrap .field-label,
.row-2 > .card .progress-wrap .field-value {
  font-size: 13px;
  font-weight: 400;
  color: #8c8c8c;
}

.card--new-install .trend .field-label {
  font-size: 13px;
  font-weight: 400;
  color: #8c8c8c;
}

.card--new-install .trend .field-value {
  font-size: 13px;
  font-weight: 600;
}

.card--new-install .trend--up .field-value {
  color: #fa8c16;
}

.card--new-install .trend--down .field-value {
  color: #52c41a;
}

.row-2 > .card .breakdown-list .bd-type {
  font-size: 14px;
  font-weight: 600;
}

.row-2 > .card .bd-type--time,
.row-2 > .card .bd-type--service {
  color: #1890ff;
}

.row-2 > .card .bd-type--traffic {
  color: #9254de;
}

.row-2 > .card .bd-primary-body .bd-num--qty .field-value,
.row-2 > .card .bd-side-row .field-value {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
}

.row-2 > .card .bd-primary-body .bd-num--amt .field-value {
  font-size: 17px;
  font-weight: 600;
  color: #262626;
}

.row-2 > .card .breakdown-list .bd-num .field-unit,
.row-2 > .card .bd-side-row .field-unit {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
}

.row-2 > .card .bd-side-row .field-label {
  font-size: 13px;
  font-weight: 400;
  color: #8c8c8c;
}

.row-2 > .card .bd-cell--rate-stack .field-label,
.row-2 > .card .bd-cell--rate-stack .field-value {
  font-size: 13px;
  font-weight: 400;
  color: #8c8c8c;
}

.metric-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 10px;
}

.metric-value--lg .num {
  font-size: clamp(23px, 2.4vw, 33px);
}

.metric-value .num {
  font-size: clamp(21px, 2.2vw, 29px);
  font-weight: 600;
  color: #1890ff;
  line-height: 1.2;
  word-break: break-all;
}

.metric-value .unit {
  font-size: 15px;
  color: #262626;
  font-weight: 600;
}

.progress-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 8px;
}

.progress-wrap .field-label,
.progress-wrap .field-value {
  font-size: 13px;
}

.progress-track {
  flex: 1;
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
  max-width: 140px;
}

.progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.3s ease;
}

.progress-fill--blue {
  background: linear-gradient(90deg, #69b1ff, #1890ff);
}

.progress-fill--purple {
  background: linear-gradient(90deg, #b37feb, #9254de);
}

.trend-row {
  display: flex;
  gap: 16px;
  margin-top: 8px;
}

.trend {
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.trend--up,
.trend--down {
  color: inherit;
}

.trend--block {
  margin-bottom: 12px;
}

/* 明细区（红框）：两行 × 多列，与设计稿对齐 */
.breakdown-list {
  margin-top: 2px;
}

.breakdown-item {
  padding: 12px 0;
  border-top: 1px solid #f0f0f0;
}

.breakdown-item:first-child {
  border-top-color: #f5f5f5;
}

.bd-grid {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
  line-height: 1.5;
}

.bd-line {
  display: grid;
  align-items: baseline;
  column-gap: 10px;
  row-gap: 2px;
  min-width: 0;
}

.bd-grid--renewal .bd-line {
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr) auto;
}

.bd-grid--install .bd-line {
  grid-template-columns: minmax(0, 1fr);
}

.bd-cell {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 6px;
  min-width: 0;
}

.bd-cell--primary {
  flex-wrap: nowrap;
  gap: 8px;
  align-items: flex-start;
}

.card--new-install .bd-cell--primary {
  align-items: center;
  width: 100%;
}

.card--new-install .bd-primary-body {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px 14px;
  min-width: 0;
}

.card--new-install .bd-primary-body .bd-type,
.card--new-install .bd-primary-body .bd-num--qty,
.card--new-install .bd-primary-body .bd-num--amt {
  grid-column: unset;
  grid-row: unset;
}

.card--new-install .bd-primary-body .bd-num--amt {
  margin-left: auto;
}

.card--new-install .bd-primary-body .bd-num--amt .field-value {
  font-size: 15px;
  font-weight: 600;
}

.card--new-install .breakdown-list .breakdown-item {
  padding: 10px 0;
}

.bd-primary-body {
  display: grid;
  grid-template-columns: auto max-content;
  column-gap: 10px;
  row-gap: 14px;
  align-items: baseline;
  min-width: 0;
}

.bd-primary-body .bd-type {
  grid-column: 1;
  grid-row: 1;
}

.bd-primary-body .bd-num--qty {
  grid-column: 2;
  grid-row: 1;
}

.bd-primary-body .bd-num--amt {
  grid-column: 2;
  grid-row: 2;
}

.bd-primary-body .bd-num--amt .field-value {
  font-size: 15px;
}

.bd-type {
  flex-shrink: 0;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
}

.bd-icon-wrap {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}

.bd-num {
  white-space: nowrap;
}

.bd-cell--mid-stack,
.bd-cell--rate-stack {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 14px;
  align-items: flex-start;
}

.bd-side-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 6px;
  min-height: 20px;
}

.bd-grid--renewal .bd-cell--rate-stack {
  align-items: flex-end;
  text-align: right;
}

.bd-grid--renewal .bd-cell--rate-stack .bd-side-row {
  justify-content: flex-end;
  width: 100%;
}

.bd-cell--rate-stack .field-label,
.bd-cell--rate-stack .field-value,
.bd-side-row .field-label,
.bd-side-row .field-value {
  font-size: 13px;
}

@media (max-width: 640px) {
  .bd-grid--renewal .bd-line {
    grid-template-columns: 1fr;
  }

  .bd-grid--install .bd-line {
    grid-template-columns: 1fr;
  }

  .bd-cell--rate-stack {
    align-items: flex-start;
  }

  .bd-primary-body {
    grid-template-columns: 1fr max-content;
  }

  .card--new-install .bd-primary-body {
    display: flex;
    flex-wrap: wrap;
  }

  .card--new-install .bd-primary-body .bd-num--amt {
    margin-left: 0;
    padding-left: 26px;
  }
}

.type-cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}

.type-card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px 18px;
  border-radius: 8px;
  overflow: hidden;
  min-height: 118px;
  color: #fff;
  box-sizing: border-box;
}

.type-card--time {
  background: #5b9fff;
}

.type-card--traffic {
  background: #9b6fd6;
}

.type-card-watermark {
  position: absolute;
  top: 6px;
  right: 10px;
  z-index: 0;
  pointer-events: none;
  display: inline-flex;
  line-height: 0;
}

.type-card-head {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  z-index: 1;
}

.type-card-icon-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #fff;
  border-radius: 6px;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.type-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  line-height: 1.3;
}

.type-card-foot {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  position: relative;
  z-index: 1;
  margin-top: 18px;
}

.type-card-count {
  display: flex;
  align-items: baseline;
  gap: 4px;
  min-width: 0;
}

.type-card-count-num {
  font-size: clamp(21px, 2.3vw, 27px);
  font-weight: 600;
  line-height: 1.15;
  color: #fff;
}

.type-card-count-unit {
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.95);
  padding-bottom: 2px;
}

.type-card-ratio {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  white-space: nowrap;
  flex-shrink: 0;
  padding-bottom: 3px;
}

.expand-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: none;
  font-size: 15px;
  color: #1890ff;
  cursor: pointer;
  transition: opacity 0.2s;
}

.expand-btn:hover {
  opacity: 0.85;
}

.card--abnormal {
  background: #fffaf5;
  border-color: #ffe7d1;
}

.abnormal-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.abnormal-item {
  text-align: center;
  padding: 12px 8px;
}

.abnormal-icon-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.abnormal-label {
  margin-bottom: 8px;
  color: #262626;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.3;
}

.abnormal-count {
  display: inline-flex;
  align-items: baseline;
  justify-content: center;
  gap: 2px;
  line-height: 1.2;
}

.abnormal-count-num {
  font-size: clamp(19px, 2vw, 23px);
  font-weight: 600;
  color: #262626;
}

.abnormal-count-unit {
  font-size: 14px;
  font-weight: 400;
  color: #262626;
  padding-bottom: 1px;
}

.card--year-new {
  background: #fff;
}

.year-new-panel,
.revenue-panel {
  width: 100%;
  padding: 18px 20px;
  background: #f0f6ff;
  border-radius: 8px;
  box-sizing: border-box;
}

.year-new-summary-top,
.revenue-col-top {
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #dce6f5;
}

.year-new-metric-label {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 10px;
}

.year-new-metric-row,
.year-new-type-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 96px;
  align-items: center;
  column-gap: 10px;
  width: 100%;
}

.year-new-metric-row {
  align-items: flex-end;
}

.year-new-metric-row .metric-value {
  margin-bottom: 0;
  min-width: 0;
  align-items: flex-end;
}

/* 今年新增 / 今年收入：顶部主数字与单位（与设计稿一致） */
.year-new-panel .metric-value--lg .num,
.revenue-panel .metric-value--lg .num {
  font-size: clamp(27px, 3vw, 35px);
  line-height: 1.1;
}

.year-new-panel .metric-value .unit,
.revenue-panel .metric-value .unit {
  font-size: 15px;
  font-weight: 400;
  color: #69b1ff;
  padding-bottom: 3px;
}

.year-new-panel .year-new-metric-label,
.revenue-panel .revenue-col-title {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
}

.year-new-stat-extra {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  width: 100%;
  white-space: nowrap;
  font-size: 13px;
  line-height: 1.5;
}

.year-new-stat-label {
  color: #8c8c8c;
  font-size: 13px;
  font-weight: 400;
}

.year-new-stat-value {
  color: #262626;
  font-size: 13px;
  font-weight: 600;
}

.year-new-trend {
  padding-bottom: 4px;
}

.year-new-types {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.year-new-type-row {
  font-size: 14px;
}

.year-new-type-left {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex-wrap: wrap;
}

.year-new-type-name {
  color: #262626;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
}

.year-new-type-count {
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
}

.year-new-panel .year-new-type-count .field-value {
  font-size: 14px;
  font-weight: 600;
}

.year-new-panel .year-new-type-count .field-unit {
  font-size: 14px;
  font-weight: 400;
  color: #8c8c8c;
}

.year-new-type-ratio {
  flex-shrink: 0;
}

.revenue-col-title {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 10px;
}

.revenue-col-bottom {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.revenue-panel .year-new-metric-row .metric-value {
  margin-bottom: 0;
  align-items: flex-end;
}

.revenue-detail-left {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
  flex-wrap: wrap;
}

.revenue-detail-name {
  font-size: 14px;
  font-weight: 400;
  color: #262626;
  white-space: nowrap;
}

.revenue-detail-val {
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
  flex-wrap: wrap;
}

.revenue-panel .revenue-detail-val .field-value {
  font-size: 14px;
  font-weight: 600;
  color: #262626;
}

.revenue-panel .revenue-detail-val .field-unit {
  font-size: 14px;
  font-weight: 400;
  color: #8c8c8c;
}

.card--revenue,
.card--year-new {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

@media (max-width: 1200px) {
  .row-2 {
    grid-template-columns: 1fr;
  }
  .abnormal-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 992px) {
  .metric-pair {
    grid-template-columns: 1fr;
  }
}
</style>
